import { useContextSelector } from 'use-context-selector';

import { TableContext } from 'components/table';

const useTable = () => {
  const selectedRows = useContextSelector(TableContext, (table) => table.selectedRows);

  const handleSelectRow = useContextSelector(TableContext, (table) => table.handleSelectRow);

  const checkSelectedRow = useContextSelector(TableContext, (table) => table.checkSelectedRow);

  const selectMultipleRows = useContextSelector(TableContext, (table) => table.selectMultipleRows);

  const triggerSelectMultipleRows = useContextSelector(
    TableContext,
    (table) => table.triggerSelectMultipleRows
  );

  const setTriggerSelectMultipleRows = useContextSelector(
    TableContext,
    (table) => table.setTriggerSelectMultipleRows
  );

  const getTableWidth = () => {
    const melverTable = document.getElementById('melver-table');

    if (melverTable) {
      return melverTable.offsetWidth;
    }

    return 0;
  };

  return {
    selectedRows,
    handleSelectRow,
    checkSelectedRow,
    selectMultipleRows,
    triggerSelectMultipleRows,
    setTriggerSelectMultipleRows,
    getTableWidth,
  };
};

export default useTable;
